var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8333 12.375C19.1785 12.375 19.4583 12.6548 19.4583 13C19.4583 16.5702 16.5702 19.4583 13 19.4583C12.7748 19.4583 12.5671 19.3372 12.4561 19.1413C12.3452 18.9453 12.3482 18.7049 12.4641 18.5118L13.3391 17.0534C13.5166 16.7575 13.9006 16.6615 14.1965 16.8391C14.4925 17.0167 14.5885 17.4006 14.4109 17.6966L14.1848 18.0734C16.4924 17.538 18.2083 15.4722 18.2083 13C18.2083 12.6548 18.4882 12.375 18.8333 12.375Z",
    fill: "#FF9999"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.8155 2.92669C4.50791 3.46205 2.79199 5.52793 2.79199 8.00008C2.79199 8.34526 2.51217 8.62508 2.16699 8.62508C1.82181 8.62508 1.54199 8.34526 1.54199 8.00008C1.54199 4.4299 4.43015 1.54175 8.00033 1.54175C8.2255 1.54175 8.43326 1.66287 8.5442 1.85881C8.65514 2.05475 8.65211 2.29522 8.53626 2.48831L7.66127 3.94664C7.48368 4.24263 7.09977 4.33861 6.80378 4.16102C6.50779 3.98343 6.41181 3.59951 6.5894 3.30352L6.8155 2.92669Z",
    fill: "#FF9999"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M10.5003 13.5833V14.0917H2.16699V13.5833C2.16699 12.1167 2.53366 11.75 4.01699 11.75H8.65032C10.1337 11.75 10.5003 12.1167 10.5003 13.5833Z",
    fill: "#FF0000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.16699 14.0916V15.3416V16.9999C2.16699 18.4666 2.53366 18.8332 4.01699 18.8332H8.65032C10.1337 18.8332 10.5003 18.4666 10.5003 16.9999V15.3416V14.0916H2.16699Z",
    fill: "#FF0000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M18.8333 4.00008V4.50841H10.5V4.00008C10.5 2.53341 10.8667 2.16675 12.35 2.16675H16.9833C18.4667 2.16675 18.8333 2.53341 18.8333 4.00008Z",
    fill: "#FF0000"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 4.5083V5.7583V7.41663C10.5 8.8833 10.8667 9.24997 12.35 9.24997H16.9833C18.4667 9.24997 18.8333 8.8833 18.8333 7.41663V5.7583V4.5083H10.5Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnect);
export default __webpack_public_path__ + "static/media/connect.68c41e6ddd15b842029e50b931a02f5c.svg";
export { ForwardRef as ReactComponent };